module.exports = __webpack_public_path__ + "catalog/items/coat-hook/coat-hook.png";